import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import { cn } from "@/shared/lib/utils";
import styles from "./Switch.module.scss";
/**
 * Visually-styled checkbox track. The actual `<input type="checkbox">` is
 * visually hidden but kept in the DOM for keyboard, click, and form semantics.
 * Wrap in a label so clicks on the track and label both toggle the input.
 */
export const Switch = React.forwardRef(({ label, onChange, className, id, checked, defaultChecked, ...rest }, ref) => {
    const reactId = React.useId();
    const inputId = id ?? reactId;
    return (_jsxs("label", { htmlFor: inputId, className: cn(styles.wrap, className), children: [_jsx("input", { ref: ref, id: inputId, type: "checkbox", className: styles.input, checked: checked, defaultChecked: defaultChecked, onChange: (e) => onChange?.(e.target.checked, e), ...rest }), _jsx("span", { className: styles.track, "aria-hidden": "true", children: _jsx("span", { className: styles.thumb }) }), label && _jsx("span", { className: styles.label, children: label })] }));
});
Switch.displayName = "Switch";
